import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Tooltip } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { setCurrentItem } from 'Actions/explore'
import { getNamespaceLabel } from 'Services/WeaverUtils'
import './GraphConsole.scss'

const QueryTable = ({ darkModeEnabled, height, setCurrentItem, width, query }) => {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [headers, setHeaders] = useState([])

  useEffect(() => {
    (async () => {
      if (query !== null) {
        setLoading(true)
        const res = await new Weaver.Sparql(query).find()
        const _headers = []
        const _rows = []
        for(let key in res) {
          _headers.push(key)
        }
        for(let i = 0; i < res[_headers[0]].length; i++) {
          const row = [];
          for(let key of _headers) {
            const item = res[key][i];
            row.push({
              value: (item instanceof Weaver.Attribute.Record) ? item.value : item.id(),
              id: (item instanceof Weaver.Attribute.Record) ? item.attNode?.id() : item.id(),
              graph: (item instanceof Weaver.Attribute.Record) ? item.attNode?.getGraph() : item.getGraph()
            })
          }
          _rows.push(row)
        }
        setHeaders(_headers)
        setRows(_rows)
        setLoading(false)
      }
    })()
  }, [query])

  const colWidth = width/headers.length || 0

  return (
    <div
      className="query-table-container"
      style={{
        bottom: `${height}px`,
        width: `${width}px`,
        backgroundColor: darkModeEnabled ? '#092837' : '#FDF6E3',
        color: darkModeEnabled ? '#fff' : '#000'
      }}
    >
      {
        loading
        ?
        <div className="query-table-loader-container">
          <LoadingOutlined style={{ fontSize: 44 }} spin />
        </div>
        :
        <table className="query-table">
          <thead className="query-table-header">
            <tr>
              {
                headers.map((val, i) =>
                  <td
                    className="query-table-cell"
                    style={{
                      minWidth: `${colWidth}px`,
                      maxWidth: `${colWidth}px`,
                      border: darkModeEnabled ? '1px solid var(--borderColor)' : '1px solid #93A1A1'
                    }}
                    key={`header-${i}`}
                  >
                    { val }
                  </td>
                )
              }
            </tr>
          </thead>
          <tbody className="query-table-body">
            { rows.map((row, i) =>
              <tr key={`row-${i}`}>
              {
                row.map((val, j) =>
                  <td
                    className="query-table-cell"
                    style={{
                      minWidth: `${colWidth}px`,
                      maxWidth: `${colWidth}px`,
                      border: darkModeEnabled ? '1px solid var(--borderColor)' : '1px solid #93A1A1'
                    }}
                    key={`row-${i}-cell-${j}`}
                    onClick={() => {
                      setCurrentItem({
                        id: val.id+'@'+val.graph,
                        label: getNamespaceLabel(val.value),
                        type: 'NODE'
                      })
                    }}
                  >
                    <Tooltip
                      title={val.value}
                      placement='topLeft'
                    >
                      { getNamespaceLabel(val.value) }
                    </Tooltip>
                </td>
              )}
             </tr>
            )}
          </tbody>
        </table>
      }
    </div>
  )
}

export default connect(({ explore }) => ({
  darkModeEnabled: explore.darkModeEnabled
})
, { setCurrentItem }
)(QueryTable)
